module.exports = __webpack_public_path__ + "img/76321.e38ee9da.svg";